import React, { Component } from 'react'
import {connect} from 'react-redux';
import {auth} from "../../actions";

import logoImg from './logo.png'

class Success extends Component{
  renderSnippet = (htmlSnippet) => {
     var checkoutContainer = document.getElementById('my-checkout-container')
     checkoutContainer.innerHTML = htmlSnippet
     var scriptsTags = checkoutContainer.getElementsByTagName('script')
     for (var i = 0; i < scriptsTags.length; i++) {
         var parentNode = scriptsTags[i].parentNode
         var newScriptTag = document.createElement('script')
         newScriptTag.type = 'text/javascript'
         newScriptTag.text = scriptsTags[i].text
         parentNode.removeChild(scriptsTags[i])
         parentNode.appendChild(newScriptTag)
     }
  }

  componentDidMount() {
    let headers = {"Content-Type": "application/json"};
    const token = this.props.token;
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch("/api/landing/klarna/confirmation", {headers, method: "POST"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(JsonResponse => {
            this.props.logout()
            return this.renderSnippet(JsonResponse.htmlSnippet)
          })
        } else {
          throw res.status
        }
     })
  }

  render() {
    return(
      <div className="Landing-container">
        <div className="Landing-header">
          <img
            src={logoImg}
            alt="Escapat logga"
            className="w-max-100"
          />
          <h1>Vinabonnemang</h1>
        </div>
        <div className="LandingSuccess">
          <h2>Ditt vinabonnemang är skapat!</h2>
          <p>
            Du kommer få ett email med inloggnings uppgifter till din abonnemang sida där
            du kan skräddarsy ditt abonnemang.
          </p>
          <div id="my-checkout-container">
            <div id="loading"></div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: ( ) => {
      return dispatch(auth.logout())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Success);



// WEBPACK FOOTER //
// ./src/containers/landing/LandingSuccess.jsx